import { render, staticRenderFns } from "./CertificateGenerate.vue?vue&type=template&id=63440ca0&scoped=true&"
import script from "./CertificateGenerate.vue?vue&type=script&lang=js&"
export * from "./CertificateGenerate.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./CertificateGenerate.vue?vue&type=style&index=1&id=63440ca0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63440ca0",
  null
  
)

export default component.exports